export class ColumnOrder {
  sortField?: string;
  sortOrder?: ColumnOrderEnum;
  key?: string;
  value?: ColumnOrderEnum;
}

export enum ColumnOrderEnum {
  descend = "descend",
  ascend = "ascend"
}
